import { render, staticRenderFns } from "./seminar-groups-modal.vue?vue&type=template&id=2e9e5aa7"
import script from "./seminar-groups-modal.vue?vue&type=script&lang=js"
export * from "./seminar-groups-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports